<h2 mat-dialog-title>Filters</h2>
<mat-dialog-content>
  <iaud-audit-filter-form [filter]="filter"></iaud-audit-filter-form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close (click)="clear()">Clear All Filters</button>
  <button mat-raised-button mat-dialog-close>Cancel</button>
  <button mat-raised-button
          [color]="'accent'"
          (click)="apply()">Apply
  </button>
</mat-dialog-actions>
